<template>
  <div>
    <list
      row-key="PurchaseArrivalId"
      ref="list"
      unit="销货单打印"
      :page="page"
      :query-params="params"
      :show-checkbox="true"
      :show-query="showQuery"
      :delete-func="api.delete"
      :get-data-func="api.PrintDetailsList"
      show-summary
      :summary-method="getSummaries"
      @check-change="checkChange"
      :pageSizes="[10, 20, 30, 40, 100, 1000]"
      isSumData
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right">
          <el-button size="mini" type="success" plain @click="onExport">导出</el-button>
          <el-button size="mini" type="primary" @click="print('qualityReceipt')" :disabled='!btntype'>小票批量打印</el-button>
          <el-button size="mini" type="primary" @click="printAll('qualityReceiptQuery')" >小票筛选打印</el-button>
        </slot>
      </template>
      <template slot="query">
        <el-form-item label="单据编号">
          <el-input
            size="mini"
            clearable
            v-model="params.DocNo"
            placeholder="请输入单据编号"
          />
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input
            size="mini"
            clearable
            v-model="params.GoodsName"
            placeholder="请输入商品名称"
          />
        </el-form-item>
        <el-form-item label="往来单位">
          <select-input
            placeholder="请选择单位"
            :label="params.CustomerName"
            v-model="params.CustomerId"
            @click="openTradeunit"
          />
        </el-form-item>
        <el-form-item label="商品分类" prop="ClassName">
          <!-- <el-input size="mini" clearable v-model="params.ClassName" placeholder="请输入商品分类" /> -->
          <el-input
            placeholder="请选择商品分类"
            v-model="params.ClassName"
            @focus="openClass"
            readonly
          ></el-input>
        </el-form-item>
        <el-form-item label="业务员" prop="ClerkName">
          <el-input
            placeholder="请选择业务员"
            v-model="params.ClerkName"
            @focus="addEmp"
            readonly
          ></el-input>
        </el-form-item>
        <template>
          <el-form-item label="单据日期">
            <el-date-picker
              size="mini"
              v-model.trim="params.DocDateStart"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd"
              style="width: 180px"
            ></el-date-picker>
            <span style="margin: 0 10px">-</span>
            <el-date-picker
              size="mini"
              v-model.trim="params.DocDateEnd"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd"
              style="width: 180px"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="是否补货">
            <el-select
              size="mini"
              v-model="params.IsRepair"
              placeholder="请选择"
              clearable
            >
              <el-option label="否" :value="0"></el-option>
              <el-option label="是" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="仓库">
            <el-input
              placeholder="请填写仓库名称"
              @focus="addwarehouse"
              readonly
              size="mini"
              v-model="params.WarehouseName"
            ></el-input>
          </el-form-item> -->
          
        <el-form-item label="所属机构">
              <el-select size="mini" v-model="params.DpId" placeholder="请选择机构" clearable>
         
                  <el-option v-for="(item,key) in DpList" :key="key" :label="item.DpName" :value="item.DpId"></el-option>
           
              </el-select>
            </el-form-item>
        </template>
      </template>
      <template slot="table">
        <el-table-column prop="DpName" label="所属机构" min-width="100px" />
        <el-table-column prop="DocNo" label="单据编号" />
      <el-table-column prop="DocDate" label="单据日期" min-width="100px">
         <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
      </el-table-column>
        <!-- <el-table-column prop="GoodsName" label="商品名称" /> -->
        <el-table-column label="来往单位" prop="CustomerName" />
        <el-table-column label="商品名称" prop="GoodsName" />
        <el-table-column prop="Model" label="规格型号" />
        <el-table-column prop="UnitName" label="单位" />
        <el-table-column prop="Quantity" label="数量" />
        <el-table-column prop="Price" label="单价" />
        <el-table-column prop="Amount" label="金额" />
        <el-table-column prop="Remark" label="备注" />
        <el-table-column label="商品分类" prop="ClassName" />
        <el-table-column label="业务员" prop="ClerkName" />
        <el-table-column prop="ExistQuantity" label="现存量" />
        <!--<el-table-column prop="AvailableQuantity" label="可用量 " />-->
        <el-table-column prop="Offer" label="报价" />
        <el-table-column prop="Discount" label="折扣%" />
        <el-table-column prop="TaxRate" label="税率/%" />
        <el-table-column prop="TaxAmount" label="税额" />
        <!--<el-table-column prop="" label="参与活动" />
        <el-table-column
          prop="ReferenceCost"
          label="预估成本单价"
          min-width="150px"
        />
        <el-table-column prop="GrossProfit" label="毛利" />-->
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <tradeunit-dialog ref="tradeunitDialog" selectable @select="setTradeunit" />
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <class-dialog
      ref="classDialog"
      selectable
      multiple
      @select="setClass"
      title="商品分类"
    />
    <warehouse-dialog
      ref="warehouseDialog"
      in-dialog
      selectable
      @select="setWarehouse"
      title="仓库列表"
      :typeList="[1, 2]"
    />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import empDialog from "@/components/sales/business/empDialog";
import tradeunitDialog from "@/components/basicinfo/basic/logistics/listDialog";
import classDialog from "@/components/basicinfo/goods/archives/goodsTree/listDialog";
import warehouseDialog from "@/components/basicinfo/basic/warehouse/listDialog";
export default {
  mixins: [listMixin],
  components: {
    list,
    tradeunitDialog,
    empDialog,
    classDialog,
    warehouseDialog,
  },
  data() {
    return {
      api: require("@/api/sale/saDoc").default,
      dpApi: require("@/api/ent/dp").default,
      params: {
        GoodsName: "",
        DocNo: "",
        DocDateStart: this.$dayjs()
        .format("YYYY-MM-DD"),
        DocDateEnd: this.$dayjs()
        .format("YYYY-MM-DD"),
        IdChain: "",
        ClassName: "",
        ClerkId: "",
        ClerkName: "",
        CustomerId: "",
        CustomerName: "",
        WarehouseName: "",
        WarehouseId: "",
        IsRepair: "",
        SortName:"DocDate,ClassId,GoodsName",
        SortOrder:"ASC,ASC,ASC",
        DpId:null//所属门店
      },
     
      isMB: this.$store.state.isMB,
      btntype:false,
      DpList:[]
    };
  },
  created(){
    this.dpApi.parentList({DpType:1}).then(res => {
       
       this.DpList = res.Data;
     })
  },
  computed: {
    date() {
      return [this.params.MonthStart, this.params.MonthEnd];
    },
    sDate() {
      return this.$dayjs().endOf("month").format("YYYY-MM-DD");
    },
    eDate() {
      return this.$dayjs()
        .subtract(3, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
    },
  },
  methods: {
    checkChange(e){
         if(e.length>0){
           this.btntype=true
         }else{
           this.btntype=false
         }
    },
    print(url) {
      let rows = this.$refs.list.getCheckedRows();
       
      sessionStorage.setItem('quality',JSON.stringify(this.checkSameData(rows)))
      let newpage = this.$router.resolve({ 
        path: '/'+url+'?sid='+ rows.map(v=>v.DocId).join(',')
      })
      window.open(newpage.href, '_blank');
    },
    printAll(url) {
     
      let newpage = this.$router.resolve({ 
        path: '/'+url,
        query:this.params
      })
      window.open(newpage.href, '_blank');
    },
    checkSameData(tableData2){
          let cache = {};  //存储的是键是GoodsId 的值，值是GoodsId 在indeces中数组的下标
          let indices = [];  //数组中每一个值是一个数组，数组中的每一个元素是原数组中相同GoodsId的下标
          tableData2.map((item,index)=>{
            let GoodsId = item.GoodsId;
            let _index = cache[GoodsId];
            if(_index!==undefined){
                 indices[_index].push(index)
            }else{
                cache[GoodsId] = indices.length
                indices.push([index])
            }
          })
          let result = [];
          indices.map((item)=>{
            item.map((index)=>{
                result.push(tableData2[index])
            })
          })
          return result
    },
    // checkChange(e) {
    //   this.$emit("check-change", e);
    // },
    setWarehouse(e) {
      this.params.WarehouseId = e.WarehouseId;
      this.params.WarehouseName = e.WarehouseName;
      // this.data.CustomerType = e.TradeUnitType
    },
    addwarehouse(e) {
      this.$refs.warehouseDialog.open().then((that) => {
        that.getData({});
        that.getTree();
      });
    },
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
      this.api.export(this.params);
    })
        .catch(() => {});
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 8 || index === 10) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return  Number(Number(Number(prev) + value).toFixed(2));
              } else {
                return Number(Number(prev).toFixed(2));
              }
            }, 0);
            sums[index] = sums[index];
          }
          return;
        }
      });
      return sums;
    },
    setEmp(e) {
      this.params.ClerkId = e.EmpId;
      this.params.ClerkName = e.EmpName;
    },
    setClass(data) {
      this.params.IdChain = data.IdChain;
      this.params.ClassName = data.ClassName;
    },
    openClass() {
      this.$refs.classDialog.open().then((that) => {
        that.getData({ Status: 1, ClassType: 6 });
      });
    },
    openTradeunit() {
      this.$refs.tradeunitDialog.open().then((that) => {
        that.getData();
      });
    },
    addEmp() {
      // let ids = this.PriAdjustEmpList.map((x) => x.EmpId);
      this.$refs.empDialog.open().then((that) => {
        that.getData({ Status: 1 });
      });
    },
    setTradeunit(data) {
      this.params.CustomerId = data.TradeUnitId;
      this.params.CustomerName = data.TradeUnitName;
    },
    dateChange(val) {
      this.params.DocDateStart = val.Start;
      this.params.DocDateEnd = val.End;
    },
    monthChange(val) {
      this.params.MonthStart = val.Start;
      this.params.MonthEnd = val.End;
    },
    onClick(row) {
      this.$refs.listDialog.open().then((that) => {
        var params = {
          TradeUnitId: row.TradeUnitId,
          TradeUnitName: row.TradeUnitName,
          DocDateStart: this.params.DocDateStart,
          DocDateEnd: this.params.DocDateEnd,
        };
        that.query(params);
      });
    },
    cycleChange(t) {
      var today = this.$commonJs.getToday();
      var start = "";
      var end = "";
      switch (t) {
        case "今天":
          start = today;
          end = today;
          break;
        case "昨天":
          start = this.$dayjs().subtract(1, "day").format("YYYY-MM-DD");
          end = start;
          break;
        case "近3天":
          start = this.$dayjs().subtract(2, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近7天":
          start = this.$dayjs().subtract(6, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近14天":
          start = this.$dayjs().subtract(13, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "本周":
          start = this.$dayjs().startOf("week").format("YYYY-MM-DD");
          end = today;
          break;
        case "上周":
          var week = this.$dayjs().subtract(1, "week");
          start = week.startOf("week").format("YYYY-MM-DD");
          end = week.endOf("week").format("YYYY-MM-DD");
          break;
        case "本月":
          start = this.$dayjs().startOf("month").format("YYYY-MM-DD");
          end = today;
          break;
        case "上月":
          var month = this.$dayjs().subtract(1, "month");
          start = month.startOf("month").format("YYYY-MM-DD");
          end = month.endOf("month").format("YYYY-MM-DD");
          break;
        case "本季":
          start = this.$dayjs().startOf("quarter").format("YYYY-MM-DD");
          end = today;
          break;
        case "上季":
          var quarter = this.$dayjs().subtract(1, "quarter");
          start = quarter.startOf("quarter").format("YYYY-MM-DD");
          end = quarter.endOf("quarter").format("YYYY-MM-DD");
          break;
        case "本年":
          start = this.$dayjs().startOf("year").format("YYYY-MM-DD");
          end = today;
          break;
        case "上年":
          var year = this.$dayjs().subtract(1, "year");
          start = year.startOf("year").format("YYYY-MM-DD");
          end = year.endOf("year").format("YYYY-MM-DD");
          break;
      }
      this.params.DocDateStart = start;
      this.params.DocDateEnd = end;
      this.query();
    },
  },
};
</script>
